module.exports = __webpack_public_path__ + "static/media/spotifylogo.31bad8d4.png";